import { Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

export const ScanQrCodeWrapper = styled(Box)`
    width: 200px;
    height: 200px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    border-radius: 16px;
    box-shadow: 0 7.368px 6.421px 0 #fff inset, 0 45.263px 27.368px 0 rgba(0, 0, 0, 0.05),
        0 20px 20px 0 rgba(0, 0, 0, 0.09), 0 1.053px 12.737px 0 rgba(0, 0, 0, 0.1);
`;
